// extracted by mini-css-extract-plugin
export var label = "_3x-1";
export var reminder = "_3x-0";